// TODO: these are defined in the shadow shader frag in BabylonJS, so can be removed when we import those shaders
varying vec2 vBumpUV;
varying vec3 vNormalW;
varying vec3 vPositionW;
varying float vHeight;

#ifdef USE_NUMBERS

#define NUMBERS_DEFAULT 1
#define NUMBERS_HIGHLIGHT_TOPFACE 2

#define NUMBERS_PULSE 1
#define NUMBERS_FADE_IN 2

#define NUMBER_PULSE_SPEED 1.5
#define HEIGHT_CUTOFF 0.35

// This controls how fine the number fadeouts are (zoom factor into noise map)
#define NUMBER_FADE_FREQ 4.0

#define vNumbersUV vBumpUV

vec4 sampleNumbersTexture(vec2 coords) {
    // Invert colors so the numbers are white on black
    vec3 numText = texture2D(numberTexture, coords).rgb;
    return vec4(1.0 - numText, numText.r);
}

vec4 stampNumbers(vec3 normal, int mode) {
    if (gl_FrontFacing == false) {
        return vec4(0.0);
    }

    // Controls mix between number color and number highlight color
    lowp float glowAmount = 0.0;

    if (lastEvent >= 2 && (mode == NUMBERS_HIGHLIGHT_TOPFACE || mode == NUMBERS_PULSE || mode == NUMBERS_FADE_IN)) {
        if (dieType == 4) {
            glowAmount = vHeight > HEIGHT_CUTOFF ? 1.0 : 0.0;
        } else {
            // topFaceNormal refers to the normal of the face that is used as the roll result.
            // Determine how similar it is to the normal of the current pixel being processed.
            // If they are very similar, this pixel is on the top face. Make it glow!
            // We want the dotproduct to be between [-1.0,1.0] so normalize the two vectors.
            float dotY = dot(normalize(topFaceNormal), normalize(normal));
            if (dotY > 0.99) {
                glowAmount = 1.0;
            }
        }
    }

    // Get raw number texture
    vec2 numTex = sampleNumbersTexture(vec2(vNumbersUV)).xz;

    numTex.y *= numberFadeCutoff;

    if (mode == NUMBERS_PULSE) {
        glowAmount = glowAmount * (0.5 + 0.5 * sin(NUMBER_PULSE_SPEED * iGlobalTime));
    } else if (mode == NUMBERS_FADE_IN) {
        float delta = lastEvent < 2 ? 0.0 : (iGlobalTime - lastEventTime);
        glowAmount = glowAmount * (1.0 - exp(-1.0 * pow((delta / fadeSpeed), 4.0)));
    }
    return vec4(numTex.x * mix(numberColor, numberHighlightColor, glowAmount), numTex.y);
}

vec2 computeNumbersDerivative() {
    vec2 dSTdx = dFdx(vNumbersUV);
    vec2 dSTdy = dFdy(vNumbersUV);
    float Hll = numberBumpScale * sampleNumbersTexture(vNumbersUV).x;
    float dBx = (numberBumpScale * sampleNumbersTexture(vNumbersUV + dSTdx).x) - Hll;
    float dBy = (numberBumpScale * sampleNumbersTexture(vNumbersUV + dSTdy).x) - Hll;
    return vec2(dBx, dBy);
}

vec3 perturbNormalArb2(vec3 surf_pos, vec3 surf_norm, vec2 dHdxy) {
    vec3 vSigmaX = vec3(dFdx(surf_pos.x), dFdx(surf_pos.y), dFdx(surf_pos.z));
    vec3 vSigmaY = vec3(dFdy(surf_pos.x), dFdy(surf_pos.y), dFdy(surf_pos.z));
    vec3 vN = surf_norm;
    vec3 R1 = cross(vSigmaY, vN);
    vec3 R2 = cross(vN, vSigmaX);
    float fDet = dot(vSigmaX, R1);
    fDet *= (float(gl_FrontFacing) * 2.0 - 1.0);
    vec3 vGrad = sign(fDet) * (dHdxy.x * R1 + dHdxy.y * R2);
    return normalize(abs(fDet) * surf_norm - vGrad);
}

vec3 bumpNumbers(vec3 normal) {
    return perturbNormalArb2(vPositionW, normal, computeNumbersDerivative());
}

#endif
